import { connect } from 'react-redux'
import Globals from '../../../globals'
import * as action from '../../state/detail/action'
import * as selector from '../../state/detail/selector'
import PhysicianAndSupplier from '../detail/PhysicianAndSupplier'


const mapStateToProps = (state, props) => {
    return {
        customer: selector.selectCustomer(state),
        physicianList: Globals.selector.selectPhysicianList(state),
        supplierList: Globals.selector.selectSupplierList(state),
        isExternalTreatmentPlanerPossible: selector.selectIsExternalTreatmentPlanerPossible(state),
        treatmentPlanerList: Globals.selector.selectTreatmentPlanerList(state),
        userList: Globals.selector.selectUserList(state),
    }
}

const mapDispatchToProps = {
    changeCustomer: action.changeCustomer,
    saveCustomer: action.saveCustomer,
}

export default connect(mapStateToProps, mapDispatchToProps)(PhysicianAndSupplier)



// WEBPACK FOOTER //
// ./src/modules/customer/component/task-widget/PhysicianAndSupplierWidgetContainer.js